import * as types from "../constants/ActionTypes";
var initialState = {};

var dataStatistical = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_DATA_STATISTICAL:
      state = action.dataStatistical;
      return { ...state };
    default:
      return { ...state };
  }
};
export default dataStatistical;
